/**
 * Retrieve the shared token from the URL's query parameters.
 * @returns {string | null} The shared token if found, otherwise null.
 */
export function getSharedTokenFromURL(): string | null {
  const urlParams = new URLSearchParams(window.location.search);

  return urlParams.get('sharedToken');
}
